// src/utils/mailer.js
import { BRAND_DEFAULTS } from "../constants/brandingDefaults";

// Detecta si estamos en Netlify (producción) o local
function getMailEndpoint() {
  const host = (typeof window !== "undefined" && window.location?.host) || "";
  const isNetlify = host.includes(".netlify.app") || host.includes("elancla.store");
  // En producción, pega directo a la Function
  if (isNetlify) return "/.netlify/functions/mail";
  // En local, primero intenta el backend Express con proxy; si no, fallback a Function
  return "/api/mail";
}

async function tryPost(url, payload) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  return res;
}

function resolveBrandingPayload(brandingOverrides) {
  if (!brandingOverrides) {
    return {
      brand_logo_url: BRAND_DEFAULTS.logo_light_url,
      brand_color: BRAND_DEFAULTS.primary_color,
      accent_color: BRAND_DEFAULTS.accent_color,
    };
  }

  const logo =
    brandingOverrides?.logos?.light ||
    brandingOverrides?.logos?.dark ||
    brandingOverrides?.logo_light_url ||
    brandingOverrides?.logo_dark_url ||
    brandingOverrides?.raw?.logo_light_url ||
    brandingOverrides?.raw?.logo_dark_url ||
    BRAND_DEFAULTS.logo_light_url;

  const brandColor =
    brandingOverrides?.colors?.primary ||
    brandingOverrides?.primary_color ||
    brandingOverrides?.raw?.primary_color ||
    BRAND_DEFAULTS.primary_color;

  const accentColor =
    brandingOverrides?.colors?.accent ||
    brandingOverrides?.accent_color ||
    brandingOverrides?.raw?.accent_color ||
    BRAND_DEFAULTS.accent_color;

  return {
    brand_logo_url: logo,
    brand_color: brandColor,
    accent_color: accentColor,
  };
}

/**
 * Envío UNIVERSAL (usa plantilla HTML universal en el backend)
 * payload mínimo: { to_email, title, ... }
 */
export async function sendUniversalEmail(params, brandingOverrides) {
  const basePayload = {
    year: new Date().getFullYear(),
    ...resolveBrandingPayload(brandingOverrides),
    ...params,
  };

  const primary = getMailEndpoint(); // "/.netlify/functions/mail" en prod, "/api/mail" en dev
  // La Function y el backend Express aceptan el mismo body (to_email/title/...).
  let res = await tryPost(primary, basePayload);

  // Si en dev no existe /api (404), intenta directo a la Function
  if (res.status === 404 && primary !== "/.netlify/functions/mail") {
    res = await tryPost("/.netlify/functions/mail", basePayload);
  }

  if (!res.ok) {
    let err; try { err = await res.json(); } catch {}
    throw new Error(err?.error || "MAIL_FAILED");
  }
  return res.json();
}

/**
 * Envío SIMPLE (html literal)
 * payload: { to, subject, html, replyTo? }
 */
export async function sendRawEmail(params) {
  const primary = getMailEndpoint();
  let res = await tryPost(primary, params);

  if (res.status === 404 && primary !== "/.netlify/functions/mail") {
    res = await tryPost("/.netlify/functions/mail", params);
  }

  if (!res.ok) {
    let err; try { err = await res.json(); } catch {}
    throw new Error(err?.error || "MAIL_FAILED");
  }
  return res.json();
}
